import React, { FC, useEffect, useMemo } from "react"
import { PrettyScheduler } from "../HomeClient/components/PrettyScheduler"
import { useLocation } from "react-router"
import { CompanyPublicData } from "../../../models"
import { getCompanyPublicDataAsync } from "../../../ajax/requests"
import { useDispatch } from "react-redux"
import { alertGenericError } from "../../../store/alerts/actions"
import { Spinner } from "reactstrap"

export const AnonymousSchedulePage: FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  const [companyData, setCompanyData] = React.useState<CompanyPublicData|undefined>(undefined);

  const companyId = useMemo(() => (location.hash && location.hash.substr(1)) || undefined, [location.hash])

  useEffect(() => {
    setCompanyData(undefined)

    if (!companyId) return
    
    getCompanyPublicDataAsync(companyId)
      .then(setCompanyData)
      .catch(e => {
        console.error(e)
        dispatch(alertGenericError())
      })
  }, [companyId]) 

  const loading = !companyData

  return (
    loading || !companyData
      ? <div style={{width: '100%', textAlign: 'center', margin: 'var(--spacer-M)'}}><Spinner/></div> 
      : <PrettyScheduler company={companyData}/>
  )
}